// Stock Checker Animation
function initStockChecker() {
    const stockSection = document.querySelector('.stock-checker');
    if (!stockSection) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Trigger animation once
                animateStockCheck();
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.5
    });

    observer.observe(stockSection);
}

function animateStockCheck() {
    const retailers = ['amazon', 'walmart', 'iherb', 'official'];

    retailers.forEach((retailer, index) => {
        const card = document.querySelector(`[data-retailer="${retailer}"]`);
        if (!card) return;

        const checkingStatus = card.querySelector('.checking');
        const finalStatus = retailer === 'official'
            ? card.querySelector('.available')
            : card.querySelector('.out-of-stock');

        // Delay each reveal sequentially (3.5s + 0.4s per card)
        setTimeout(() => {
            // Hide checking
            checkingStatus.style.display = 'none';

            // Show final status with animation
            finalStatus.style.display = 'flex';
            finalStatus.style.opacity = '0';
            finalStatus.style.transform = 'scale(0.8)';

            setTimeout(() => {
                finalStatus.style.transition = 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)';
                finalStatus.style.opacity = '1';
                finalStatus.style.transform = 'scale(1)';

                // Add green background for official store
                if (retailer === 'official') {
                    card.classList.add('stock-revealed');
                }
            }, 50);

            // Change to "GET TODAY" for official store after 2s
            if (retailer === 'official') {
                setTimeout(() => {
                    const stockText = card.querySelector('.stock-text');
                    if (stockText) {
                        stockText.style.transition = 'opacity 0.3s ease';
                        stockText.style.opacity = '0';

                        setTimeout(() => {
                            stockText.textContent = 'GET TODAY';
                            stockText.style.opacity = '1';
                        }, 300);
                    }
                }, 2000);
            }
        }, 3500 + (index * 400)); // 3.5s initial + 400ms stagger
    });
}

// Initialize on load
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStockChecker);
} else {
    initStockChecker();
}
